import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { isNotNil } from '@web/utils';

@Component({
  selector: 'app-public-box-carousel-item',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-box-carousel-item.component.html',
  styleUrl: './public-box-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxCarouselItemComponent {
  public readonly imageSrc = input.required<string>();
  public readonly imageAlt = input.required<string>();

  protected readonly isNotNil = isNotNil;
}
